export default __webpack_public_path__ + "static/django-72baec960c9be2b8ce12d436583a44ff.svg";